export const runId = $localize`runID`;
export const runName = $localize`runName`;
export const user = $localize`user`;
export const uploadedOn = $localize`uploadedOn`;
export const status = $localize`Status`;
export const size = $localize`size`;
export const groupName = $localize`Project`;

export const displayedColumns = [`runName`, `groupName`, `user`, `size`, `uploadedOn`, `status`];
